<template>
  <div class="scroll-down-text">
    <p>scroll down</p>
    <div class="scroll-down-text__arrow" />
  </div>
</template>
<script>
export default {
  name: 'ScrollDownText'
}
</script>
<style lang="scss" scoped>
.scroll-down-text {
  p {
    font-family: Avenir;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 200%;
    text-align: end;
    letter-spacing: 0.06em;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  &__arrow {
    width: 1px;
    height: 100px;
    margin: 50px auto 0;
    background-color: transparent;
    position: relative;
    overflow: hidden;
  }

  &__arrow::before {
    content: '';
    width: 2px;
    height: 100px;
    margin: 50px auto 0;
    background-color: $black;
    position: absolute;
    top: -150px;
    left: 0;
    -webkit-animation: arrow 2.5s ease 0s infinite normal;
    animation: arrow 2.5s ease 0s infinite normal;
  }

  @keyframes arrow {
    0% {
      -webkit-transform: translate3d(-50%, 0, 0);
      transform: translate3d(-50%, 0, 0);
    }

    60% {
      -webkit-transform: translate3d(-50%, 100px, 0);
      transform: translate3d(-50%, 100px, 0);
    }

    100% {
      -webkit-transform: translate3d(-50%, 100px, 0);
      transform: translate3d(-50%, 100px, 0);
    }
  }
}
</style>
